<template>
   <div class="customer">
      <div class="filter">
         <Form 
            class_binding="row justify-content-md-center" 
            :ref="Model.forms.filter_customers.name" 
            :forms="Model.forms.filter_customers.forms" 
            :form_data="Model.forms.filter_customers.data"
            @button-click="filterCustomers({ref: $refs[Model.forms.filter_customers.name]})"
         />
      </div>
      
      <div class="dotted-border" v-if="customers.length === 0">
         <div class="row justify-content-md-center">
            <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
               <div class="btn btn-transparent btn-primary btn-round"><div :class="Model.tables.customer.props.icon"></div></div>
               <div class="title">{{Model.tables.customer.props.title}}</div>
               <div class="subtitle">
                  No Customers found! Query to continue.
               </div>
            </div>
         </div>
      </div>
      
      <Table v-bind="Model.tables.customer.props" :data="customers" @on-action="handleActions" v-if="customers.length > 0"/>
   </div>
</template>

<script>
import customer from "./customer.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('customer')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('customer',customer,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'Model',
         'customers',
         'show_create_modal',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'filterCustomers',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('customer',customer,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .customer{
      
   }
</style>